import { computed, inject } from '@angular/core';
import { signalStore, type, withComputed, withProps } from '@ngrx/signals';
import { entityConfig, withEntities } from '@ngrx/signals/entities';
import {
  withEntitiesLoadingCall,
  withCallStatus,
  withEntitiesLocalSort,
  withLogger,
} from '@ngrx-traits/signals';
import { Feature, FeatureService } from '..';
import { map } from 'rxjs';

const featureConfig = entityConfig({
  entity: type<Feature>(),
  collection: 'feature',
});

export const FeatureStore = signalStore(
  withEntities(featureConfig),
  withCallStatus(featureConfig, {
    initialValue: 'loading',
  }),
  withEntitiesLocalSort(
    { entity: type<Feature>(), collection: featureConfig.collection },
    {
      defaultSort: { field: 'name', direction: 'asc' },
    }
  ),
  withLogger({
    name: 'FeatureStore',
    showDiff: true,
  }),
  withProps(() => ({
    _featureService: inject(FeatureService),
  })),
  withEntitiesLoadingCall(({ _featureService }) => ({
    collection: featureConfig.collection,
    fetchEntities: () =>
      _featureService.loadFeatures().pipe(
        map((response) => ({
          entities: response.result,
          total: response.count,
        }))
      ),
  })),
  withComputed(({ featureEntities }) => ({
    options: computed(() => featureEntities().map(featureToOption)),
  }))
);

const featureToOption = (feature: Feature) => ({
  value: feature.id.toString(),
  label: feature.name,
  metadata: feature,
});
